import { systemProp2qpti4y1f5b4b as systemProp } from '../internal/SystemProps.common.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance,
} from './BufferOverflow.mjs';
import { ConflatedBufferedChannel16nes42ao4b78 as ConflatedBufferedChannel } from './ConflatedBufferedChannel.mjs';
import { BufferedChannel3lgkhzot5gmk6 as BufferedChannel } from './BufferedChannel.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FactoryClass;
function Factory() {
  if (FactoryClass === VOID) {
    class $ {
      constructor() {
        Factory_instance = this;
        this.s1b_1 = 2147483647;
        this.t1b_1 = 0;
        this.u1b_1 = -1;
        this.v1b_1 = -2;
        this.w1b_1 = -3;
        this.x1b_1 = 'kotlinx.coroutines.channels.defaultBuffer';
        this.y1b_1 = systemProp('kotlinx.coroutines.channels.defaultBuffer', 64, 1, 2147483646);
      }
    }
    initMetadataForObject($, 'Factory');
    FactoryClass = $;
  }
  return FactoryClass;
}
var Factory_instance;
function Factory_getInstance() {
  if (Factory_instance === VOID)
    new (Factory())();
  return Factory_instance;
}
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.nx(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.nx.call(this, cause);
  }
  return tmp;
}
var ReceiveChannelClass;
function ReceiveChannel() {
  if (ReceiveChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ReceiveChannel', VOID, VOID, VOID, [0]);
    ReceiveChannelClass = $;
  }
  return ReceiveChannelClass;
}
function close$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  return $super === VOID ? this.n1b(cause) : $super.n1b.call(this, cause);
}
var SendChannelClass;
function SendChannel() {
  if (SendChannelClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SendChannel', VOID, VOID, VOID, [1]);
    SendChannelClass = $;
  }
  return SendChannelClass;
}
function _ChannelResult___init__impl__siwsuf(holder) {
  return holder;
}
function _ChannelResult___get_holder__impl__pm9gzw($this) {
  return $this;
}
function _ChannelResult___get_isSuccess__impl__odq1z9($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return !(tmp instanceof Failed());
}
function _ChannelResult___get_isClosed__impl__mg7kuu($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  return tmp instanceof Closed();
}
function ChannelResult__getOrNull_impl_f5e07h($this) {
  var tmp;
  var tmp_0 = _ChannelResult___get_holder__impl__pm9gzw($this);
  if (!(tmp_0 instanceof Failed())) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  } else {
    tmp = null;
  }
  return tmp;
}
function ChannelResult__exceptionOrNull_impl_16ei30($this) {
  var tmp = _ChannelResult___get_holder__impl__pm9gzw($this);
  var tmp0_safe_receiver = tmp instanceof Closed() ? tmp : null;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z1b_1;
}
var FailedClass;
function Failed() {
  if (FailedClass === VOID) {
    class $ {
      toString() {
        return 'Failed';
      }
    }
    initMetadataForClass($, 'Failed', Failed);
    FailedClass = $;
  }
  return FailedClass;
}
var ClosedClass;
function Closed() {
  if (ClosedClass === VOID) {
    class $ extends Failed() {
      constructor(cause) {
        super();
        this.z1b_1 = cause;
      }
      equals(other) {
        var tmp;
        if (other instanceof Closed()) {
          tmp = equals(this.z1b_1, other.z1b_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.z1b_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      }
      toString() {
        return 'Closed(' + toString_0(this.z1b_1) + ')';
      }
    }
    initMetadataForClass($, 'Closed');
    ClosedClass = $;
  }
  return ClosedClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.f1a_1 = new (Failed())();
      }
      g1a(value) {
        return _ChannelResult___init__impl__siwsuf(value);
      }
      f1b() {
        return _ChannelResult___init__impl__siwsuf(this.f1a_1);
      }
      z1a(cause) {
        return _ChannelResult___init__impl__siwsuf(new (Closed())(cause));
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function ChannelResult__toString_impl_rrcqu7($this) {
  var tmp;
  if (_ChannelResult___get_holder__impl__pm9gzw($this) instanceof Closed()) {
    tmp = _ChannelResult___get_holder__impl__pm9gzw($this).toString();
  } else {
    tmp = 'Value(' + toString_0(_ChannelResult___get_holder__impl__pm9gzw($this)) + ')';
  }
  return tmp;
}
function ChannelResult__hashCode_impl_lilec2($this) {
  return $this == null ? 0 : hashCode($this);
}
function ChannelResult__equals_impl_f471ri($this, other) {
  if (!(other instanceof ChannelResult()))
    return false;
  var tmp0_other_with_cast = other.c1b_1;
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ChannelResultClass;
function ChannelResult() {
  if (ChannelResultClass === VOID) {
    class $ {
      constructor(holder) {
        Companion_getInstance();
        this.c1b_1 = holder;
      }
      toString() {
        return ChannelResult__toString_impl_rrcqu7(this.c1b_1);
      }
      hashCode() {
        return ChannelResult__hashCode_impl_lilec2(this.c1b_1);
      }
      equals(other) {
        return ChannelResult__equals_impl_f471ri(this.c1b_1, other);
      }
    }
    initMetadataForClass($, 'ChannelResult');
    ChannelResultClass = $;
  }
  return ChannelResultClass;
}
var ClosedReceiveChannelExceptionClass;
function ClosedReceiveChannelException() {
  if (ClosedReceiveChannelExceptionClass === VOID) {
    class $ extends NoSuchElementException() {
      static v1a(message) {
        var $this = this.a2(message);
        captureStack($this, $this.u1a_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedReceiveChannelException');
    ClosedReceiveChannelExceptionClass = $;
  }
  return ClosedReceiveChannelExceptionClass;
}
var ClosedSendChannelExceptionClass;
function ClosedSendChannelException() {
  if (ClosedSendChannelExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static l1b(message) {
        var $this = this.o(message);
        captureStack($this, $this.k1b_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ClosedSendChannelException');
    ClosedSendChannelExceptionClass = $;
  }
  return ClosedSendChannelExceptionClass;
}
function Channel(capacity, onBufferOverflow, onUndeliveredElement) {
  capacity = capacity === VOID ? 0 : capacity;
  onBufferOverflow = onBufferOverflow === VOID ? BufferOverflow_SUSPEND_getInstance() : onBufferOverflow;
  onUndeliveredElement = onUndeliveredElement === VOID ? null : onUndeliveredElement;
  var tmp;
  switch (capacity) {
    case 0:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new (BufferedChannel())(0, onUndeliveredElement) : new (ConflatedBufferedChannel())(1, onBufferOverflow, onUndeliveredElement);
      break;
    case -1:
      // Inline function 'kotlin.require' call

      if (!onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance())) {
        var message = 'CONFLATED capacity cannot be used with non-default onBufferOverflow';
        throw IllegalArgumentException().n2(toString(message));
      }

      tmp = new (ConflatedBufferedChannel())(1, BufferOverflow_DROP_OLDEST_getInstance(), onUndeliveredElement);
      break;
    case 2147483647:
      tmp = new (BufferedChannel())(2147483647, onUndeliveredElement);
      break;
    case -2:
      tmp = onBufferOverflow.equals(BufferOverflow_SUSPEND_getInstance()) ? new (BufferedChannel())(Factory_getInstance().y1b_1, onUndeliveredElement) : new (ConflatedBufferedChannel())(1, onBufferOverflow, onUndeliveredElement);
      break;
    default:
      tmp = onBufferOverflow === BufferOverflow_SUSPEND_getInstance() ? new (BufferedChannel())(capacity, onUndeliveredElement) : new (ConflatedBufferedChannel())(capacity, onBufferOverflow, onUndeliveredElement);
      break;
  }
  return tmp;
}
//region block: exports
export {
  Factory_getInstance as Factory_getInstance3boxsed5qz5iy,
  Companion_getInstance as Companion_getInstance2d24j5bn8excb,
  cancel$default as cancel$default1fq6eekptkf7a,
  close$default as close$default1evna6yun3t5h,
  ChannelResult__exceptionOrNull_impl_16ei30 as ChannelResult__exceptionOrNull_impl_16ei302e9q7b2jc90dz,
  ChannelResult__getOrNull_impl_f5e07h as ChannelResult__getOrNull_impl_f5e07h25z6we1ochnsd,
  _ChannelResult___get_holder__impl__pm9gzw as _ChannelResult___get_holder__impl__pm9gzw2tjepaj1eg2kq,
  _ChannelResult___get_isClosed__impl__mg7kuu as _ChannelResult___get_isClosed__impl__mg7kuu1g5u2zmbzbfb4,
  _ChannelResult___get_isSuccess__impl__odq1z9 as _ChannelResult___get_isSuccess__impl__odq1z912b5ogo8613be,
  Closed as Closed8t4xgopf7j5r,
  ChannelResult as ChannelResult2y4k69ac6y3du,
  Channel as Channel3r72atmcithql,
  ClosedReceiveChannelException as ClosedReceiveChannelException3ofg6gf5f5b38,
  ClosedSendChannelException as ClosedSendChannelException29m33prpq9jaw,
  ReceiveChannel as ReceiveChannel24wu5e2tj9lbp,
  SendChannel as SendChannel38sllbxw662ws,
};
//endregion

//# sourceMappingURL=Channel.mjs.map
